import { createContext } from "react";

interface DataTableColumnOrder {
  columnOrder: string[];
}

const DataTableColumnOrderContext = createContext<DataTableColumnOrder | null>(
  null,
);

export default DataTableColumnOrderContext;
